import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_vietnamese_pastry.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganPP() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Puff Pastry (Pâté Chaud)",
    content_category: "Vegan Menu",
    content_ids: ["vegan_puff_pastry"],
    content_type: "vegan_vietnamese_pastries",
    value: 3.5,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Puff Pastry (Pâté Chaud) | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Savor the crispy goodness of our Vegan Puff Pastry (Pâté Chaud), filled with a savory blend of soy, mushrooms, veggies, and perfectly balanced spices. This plant-based take on the classic Vietnamese pastry delivers rich, satisfying flavors in a convenient, grab-and-go size—perfect for any time of day."
        />
        <meta property="og:title" content="Vegan Puff Pastry (Pâté Chaud) | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="Savor the crispy goodness of our Vegan Puff Pastry (Pâté Chaud), filled with a savory blend of soy, mushrooms, veggies, and perfectly balanced spices. This plant-based take on the classic Vietnamese pastry delivers rich, satisfying flavors in a convenient, grab-and-go size—perfect for any time of day."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          // FORCE large title + subtitle on two lines, regardless of internal Typography defaults
          titleHead={
            <span
              style={{
                display: "inline-block",
                color: "#fff",
                fontWeight: 800,
                letterSpacing: "-0.02em",
                textTransform: "uppercase",
                lineHeight: 1.1,
                // responsive clamp to keep it big but graceful
                fontSize: "clamp(26px, 5vw, 36px)",
              }}
            >
              VEGAN PUFF PASTRY
              <br />
              <span
                style={{
                  fontStyle: "italic",
                  fontWeight: 500,
                  textTransform: "none",
                  opacity: 0.9,
                  // keep subtitle clearly smaller than title
                  fontSize: "clamp(14px, 2.2vw, 18px)",
                }}
              >
                (Pâté Chaud Chay)
              </span>
            </span>
          }
          // Add clear vertical spacing above the price to separate from the subtitle
          titleSubHead={
            <span
              style={{
                display: "inline-block",
                marginTop: "10px",
                color: "#fff",
                fontWeight: 700,
              }}
            >
              $3.50 each
            </span>
          }
          detailBody="Savor the crispy goodness of our Vegan Puff Pastry (Pâté Chaud Chay), filled with a savory blend of soy, mushrooms, veggies, and perfectly balanced spices. This plant-based take on the classic Vietnamese pastry delivers rich, satisfying flavors in a convenient, grab-and-go size—perfect for any time of day."
          detailBodyBr={
            <>
              Contains: wheat, soy, sesame, almond
              <br />
              <br />
              <em>Vegan</em>
            </>
          }
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganPP;